export default __webpack_public_path__ + "static/snowflakes-9925708b3218c55ac8c04d6a9a047725.svg";